module.exports = __webpack_public_path__ + "media/images/front/top/2-c7dd8af0e632a4f1052e01f36ba564da.jpg";